import React from "react";
import "../styles/Hero.css";
import { HERO_CONSTANTS } from "../utils/travel_esims";

const Hero = () => {
  return (
    <div className="hero-content">
      <div>
        <span className="hero-tag">{HERO_CONSTANTS.TAG}</span>
        <span className="mid-dot">&middot;</span>
        <span>{HERO_CONSTANTS.DATE}</span>
      </div>
      <h1>{HERO_CONSTANTS.TITLE}</h1>
      <p>{HERO_CONSTANTS.DESCRIPTION}</p>
      <img
        src={HERO_CONSTANTS.HERO_IMAGE}
        alt="Harvest"
        className="hero-image"
      />
    </div>
  );
};

export default Hero;
